import { ContactFormData } from '@/types/contactInformation';

export async function submitContactForm(formData: ContactFormData) {
  try {
    // eslint-disable-next-line no-undef
    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    const result = await res.json();

    if (!res.ok) {
      return {
        success: false,
        error: result.error || `Request failed: ${res.status}`,
      };
    }

    return { success: result.ok, id: result.id };
  } catch (error) {
    console.error('Contact form error:', error);
    return {
      success: false,
      error: 'Network error. Please check your connection and try again.',
    };
  }
}
